import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import { getGeoJSON } from './ManagedGeoJSON';
export const featureToGeoJSONObject = (feature) => getGeoJSON(feature);
export const pointToGeoJSONObject = (point) => {
    const olFeature = new Feature({
        geometry: new Point(point),
    });
    return getGeoJSON(olFeature);
};
//# sourceMappingURL=featureToGeoJSONObject.js.map